import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Hack4tts_Intro from "./Hack4tts_Intro"; // update path accordingly

function Hack4TTSModalPopup() {
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  return (
    <>
    <div className="registers-container">
      {/* <Button onClick={handleShow} className="regist-btn-outline">
        Click Here for more info
      </Button>  */}
      <a onClick={handleShow} className="regist-btn-outline">
        Read More
      </a> 
    </div>

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Voice Tech for All: Introduction</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Hack4tts_Intro />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Hack4TTSModalPopup;
